import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject, Input, ViewEncapsulation } from '@angular/core';
import { WidgetSettingsService } from '../../../services/widget-settings.service';
import { HomepageService } from '../../../services/homepage.service';
import { RouterExtService } from '../../../services/previous-route.service';
import { AuthService } from '../../../services/auth.service';
import {DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import {Router} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NotifierService } from 'angular-notifier';
import { event } from 'jquery';
import { take } from 'rxjs/operators';
import { TenantService } from '../../../services/tenant.service';
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css'],
   encapsulation: ViewEncapsulation.None
})
export class HomepageComponent implements OnInit {

  private readonly notifier: NotifierService;
  private themes:any = {'default':'summertime', 'dark-theme':'luna', 'SleekAndRelaxed':'berry', 'violet-theme':'mochablue', 'kids1-theme':'birthdayCake', 'kids1-theme kids2-theme':'playground', 'kids1-theme christmas-theme':'christmas', 'kids1-theme beach-theme':'beach'};
  
  isLogin: any = '';
  authToken: any ='';
  authTok: any ='';

 	constructor( private cookieService: CookieService,private homepageService : HomepageService,@Inject(DOCUMENT) private document: Document,private routerService: RouterExtService, private authService: AuthService, private widgetSettingsService: WidgetSettingsService, private router: Router,notifierService: NotifierService, private tenantService: TenantService ) {
    //checking for theme to change inner banner and other attributes.
    this.homepageService.theme$.subscribe(theme => {
      //console.log(theme, '++++++++');
      this.theme = theme;
    });
    this.homepageService.isLogin$.subscribe((resultList: any) => {
      this.optionsEditor.requestHeaders.Authorization = 'Bearer '+localStorage.getItem('token');
      if(resultList == 'true'){
        this.isLogin = resultList;
        this.init()
      }
      //this.openSettingTab(event);
      // if(this.isLogin){
      //    this.authToken = localStorage.getItem('token');
      // }
    });
   // this.authToken = this.homepageService.getAuthorization(this.authTok);

    this.notifier = notifierService;
    this.router.events.subscribe((val) => {
      this.document.body.classList.remove('manage-view');   
    });
    this.optionsEditor.requestHeaders.tenant = this.tenantService.tenant;
    this.optionsEditor.requestHeaders.configuration = this.tenantService.configurationSetting;
  }
 
  themeColors = {
    'summertime' : ['#26b6ef', '#ffca51', '#26b6ef', '#dadada', '#131313'],
    'berry' : ['#7283fe', '#f29085', '#c5ccff', '#d2d2d2', '#0a0a3a'],
    'mochablue' : ['#bc9b64', '#072a55', '#2d77d3', '#779dc0', '#072a55'],
    'luna' : ['#6a6e71', '#87c232', '#222629', '#a7a7a7', '#2d3236'],
    'birthdayCake' : ['#25c393', '#f077ac', '#25c393', '#ffffff', '#f077ac'],
    'playground' : ['#f96767', '#25c393', '#1da97e', '#ffffff', '#25c393'],
    'christmas' : ['#067836', '#e44356', '#00923d', '#ffffff', '#00923d'],
    'beach' : ['#03baca', '#f2ceae', '#ed42aa', '#ffffff', '#00d6e8'] //ed42aa
  };
  
 	gloalSetting: any = [];
	responseAPIstatus: boolean = true;
	widgetsSetting: any = [];
  conditionallyCall: boolean;
  editMode: boolean = false;
  settingHt : number;
  sizeOptions : object = [3,6,9,12];
  showManageWidhetsForm: boolean = false;
  resourceLists: any[];
  explorePage: any[];
  bulletinList: any[];
  addWidgetResponce: boolean = false;
  isStartRatingDisable: boolean = true;
  hidePopularTitles: boolean = false;
  tetent: any = '';
  confiGurationSetting: any = '*';
  token: any = '';   
  qaImagesList:any = [];
  QaImagesList: boolean = false;
  fileToUpload: File = null;
  showPaletteBox:boolean = false;
  theme:any = 'default';
  tempTenant:string = '';
  custumThemeLoad: boolean = false;
  showDeleteConfirm: boolean = false;
  deleteWidgetId: number = 0;
  deleteWidgetEvent: any = null;
  halfWidgetCount: number = 0;
  leftWidgetHeight: number = 0;
  rightWidgetHeight: number = 0;
  defaultMargin: number = 160;
  defaultMarginInEditMode: number = 70;
  isReload: boolean = false;
  
  public color1:string = '#bc9b64'; 
  public color2:string = '#072a55'; 
  public color3:string = '#2d77d3'; 
  public color4:string = '#719dc0';
  public color5:string = '#072a55';
  ngOnInit() {
   
   if(!this.isLogin){
    this.init()
   }
    
  }

  // RY widget resolved into Popular-fallback mode; suppress any separate Popular Titles widget to avoid duplication.
  // When RY is NOT showing Popular in its place (real recommendations, login prompt, etc.) the regular
  // Popular Titles widget must be shown again, so mirror the state both ways.
  onRecommendedShowingPopular(showing: boolean) {
    this.hidePopularTitles = showing;
  }

  init(){
    sessionStorage.setItem('lastSearchKeyword','defaultsearchkeywordtest');
    // sessionStorage.removeItem('lastSearchLocation');
    this.document.body.classList.remove('inner-page');
    this.document.body.classList.remove('list');
   // 
 		this.getwidgetsSettings();
    this.routerService.setTextUrl('Home');

    //Getting widget data for resource, explore, bulletins.
   
    
  }

  public calculateSpanElementMargin(widgrts: any, spanElement: HTMLElement) {
    if(widgrts.settings.width && widgrts.settings.width === 'H'){
      var currentWidgetHeight = spanElement.offsetHeight;
      if(this.halfWidgetCount === 0){
        this.leftWidgetHeight = currentWidgetHeight;
      }else if(this.halfWidgetCount > 0){
        this.rightWidgetHeight += currentWidgetHeight;
      }
      this.halfWidgetCount += 1;
    }else{
      this.halfWidgetCount = 0;
      this.leftWidgetHeight = 0;
      this.rightWidgetHeight = 0;
    }
    if(this.halfWidgetCount > 1 && ((this.rightWidgetHeight + this.defaultMargin) > this.leftWidgetHeight) && !this.editMode){
      var marginBottom = this.leftWidgetHeight - this.rightWidgetHeight;
      if(marginBottom > 0){
        this.halfWidgetCount = 0;
        this.leftWidgetHeight = 0;
        this.rightWidgetHeight = 0;
        return marginBottom + 1;
      }
    }else if(this.halfWidgetCount > 1 && (this.rightWidgetHeight + this.defaultMarginInEditMode > this.leftWidgetHeight) && this.editMode){
      var marginBottom = this.leftWidgetHeight - this.rightWidgetHeight;
      if(marginBottom > 0){
        this.halfWidgetCount = 0;
        this.leftWidgetHeight = 0;
        this.rightWidgetHeight = 0;
        return marginBottom + 1;
      }
    }
    return 0;
  }

  changeWidgetSettingPosition(id: any, newIndex: number): void {
    const indexFrom = this.widgetsSetting.data.findIndex((widget: any) => widget.id === id);

    if (indexFrom === -1 || newIndex < 0 || newIndex >= this.widgetsSetting.data.length) {
      console.error('Invalid index or ID');
      return;
    }
    const itemToMove = this.widgetsSetting.data.splice(indexFrom, 1)[0];
    this.widgetsSetting.data.splice(newIndex, 0, itemToMove);
  }

  ngAfterViewInit() {
    var $this = this;
    setTimeout(function(){
      $this.tempTenant = localStorage.getItem('loadedtenant');
      //console.log($this.gloalSetting);
    },3000);
  //this.authToken = this.homepageService.getAuthorization(this.authTok);
  // console.log(this.authToken);

  }
  

  //Editors for widgets.
  
  public optionsEditor: any = {
    key: '6LF5g1D4A3B2B5D5E4F-11SLJCKHXOSLMc1YGSGb1ZXHSe1CgB5A4D4A3E3C2A13A19B6C6==',  
    toolbarInline: false,
    attribution:false,
    toolbarVisibleWithoutSelection: true,
    filesManagerUploadParam: 'file',
    filesManagerUploadMethod: 'post',
    filesManagerAllowedTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/webp'],
    filesManagerUploadURL: 'https://api.library.site/v1/widget/image/upload',
    imageStyles: {
      class1: 'Class 1',
      class2: 'Class 2'
    },
    
    imageUploadMethod: 'post',
    requestHeaders: {
      tenant: '', 
      configuration : this.confiGurationSetting,
      Authorization : "Bearer "+ localStorage.getItem('token'),
    
    },
    
    
    imageUploadURL: 'https://api.library.site/v1/widget/image/upload',  
    events: {
         'image.uploaded': function (response) {
         var img_url = JSON.parse(response).data.link;
         this.image.insert(img_url, false, null, this.image.get(), response);       
         return false;
      }
    },
    imageEditButtons: ['imageReplace', 'imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize']  
  };
  

  // Setting options for editors.
  public option = { 
    animation: 150,
    handle: '.my-handle',
    sort: true,
    group: 'widgets', 
    direction : 'vertical', 
    dragoverBubble: true,
    removeCloneOnHide: false ,
    onUpdate: (event: any) => {
      this.onSortFinish(event);
    }
  }

  //Getting Library Configurations.
 	getSavedConfig(){
      this.gloalSetting = this.homepageService.getUpdatedConfig();
      if(localStorage.getItem('theme') !== null){ 
        var tempThemeName = localStorage.getItem('theme');
        if(tempThemeName.indexOf('custom') > -1 ){  
          var customColors = tempThemeName.split(' ');  
          this.color1 = customColors[1];
          this.color2 = customColors[2];
          this.color3 = customColors[3];
          this.color4 = customColors[4];
          this.color5 = customColors[5];
        }else{
          this.updateColors(tempThemeName);
        }
      }
      this.responseAPIstatus =  false;
      if(this.gloalSetting.data.settings.ratings.enabled && this.gloalSetting.data.settings.ratings.loginRequired){
        //if(this.cookieService.check( 'info')){  
        if (localStorage.getItem('info')){   
          this.isStartRatingDisable = false;
        } else{
          this.isStartRatingDisable = true;
        }
      } else if(this.gloalSetting.data.settings.ratings.enabled && !this.gloalSetting.data.settings.ratings.loginRequired){
        this.isStartRatingDisable = false;
      } else if(!this.gloalSetting.data.settings.ratings.enabled){
        this.isStartRatingDisable = true;
      } 
  }
 	
  //To get widget settings.
 	getwidgetsSettings() {
      this.conditionallyCall = this.homepageService.checkContentHave();
      if(this.conditionallyCall === true){
         this.homepageService.getwidgetsupdatedSetting().subscribe((data: any) => {
          this.widgetsSetting = data;              
          this.getSavedConfig();
        });
          //this.widgetsSetting = this.homepageService.getwidgetsSettingDataSave();
          //this.getSavedConfig();
      } else {
        this.homepageService.getwidgetsSetting().subscribe((data: any) => {
          this.widgetsSetting = data;              
          this.getSavedConfig();
        });
      }
    }

    // Enable/Disable edit mode.
    editModeEnable(){
      if($('#enableMode').is(':checked')){
        this.editMode = true;      
        this.document.body.classList.add('manage-view');
        //$('#enableMode').addClass('edit');
      } else {
        this.editMode = false;        
        this.document.body.classList.remove('manage-view');
        //$('#enableMode').removeClass('edit');
      }
      
    }

    // Show widget form.
    showManageWidgetform(){
      $("button.addWdgt").on("mouseover", function(){
        $('.instructions-editmode').addClass('hide').removeClass('show'); 
        var ActWidget = $(this).attr('id');
        $('#ins'+ActWidget).removeClass('hide').addClass('show');
      });
      if(this.showManageWidhetsForm === true){
        this.showManageWidhetsForm = false;
      } else {
        this.showManageWidhetsForm = true;
        this.showPaletteBox = false;
      }
    }

    //Hide widget form.
    hideManageWidgetform() {
      this.showManageWidhetsForm = false;
    }

    //Show theme pallete.
    showPalette(){
      if(this.showPaletteBox === true){
        this.showPaletteBox = false;
      } else {
        this.showPaletteBox = true;
        this.showManageWidhetsForm = false;
      }
    }

    //Hide theme pallette.
    hidePalette() {
      this.showPaletteBox = false;
    }

    // To show/hide edit buttons.
    openSettingTab(event){
      if(!$('#editModeButton').hasClass('edit')){
        this.editMode = true;      
        this.document.body.classList.add('manage-view');
        this.optionsEditor.requestHeaders.Authorization = "Bearer "+localStorage.getItem('token');
        $('#editModeButton').addClass('edit');
         
      } else {        
        this.editMode = false;        
        this.document.body.classList.remove('manage-view');
        $('#editModeButton').removeClass('edit');
        if(this.isReload){        
          window.location.href = "/"
        }
      }
    }



  //Edit logo banner.
  editLogobanner(event){         
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      this.optionsEditor.requestHeaders.Authorization = 'Bearer '+localStorage.getItem('token');    
    }
    if(event.target.nodeName.toLowerCase() == 'button'){      
      var checkBoxName = $(event.target).parent().next('.editwidgets').find('.viewSetting:first').attr('name');    
      var vt = $(event.target).parent().next('.editwidgets').find('input[name="'+checkBoxName+'"]:checked').val();
      if($(event.target).hasClass('open')){
          $(event.target).parent().next('.editwidgets').animate({bottom: "50%",'opacity': 0},200,'linear', function(){
            $(event.target).removeClass('open');
            $(event.target).parent().next('.editwidgets').removeClass('open');
            $(event.target).parents('.example-box').removeClass('open');   
            $(event.target).parents('.example-box').find('section.widgets').css('min-height','auto');
          });
      } else {
        this.settingHt = $(event.target).addClass('open').parent().next('.editwidgets').outerHeight() + 50;
        $(event.target).parents('.example-box').find('section.widgets').css('min-height',this.settingHt);
        $(event.target).addClass('open').parent().next('.editwidgets').addClass('open').animate({bottom: "50%",'opacity': 1},200,'linear');    
        $(event.target).parents('.example-box').addClass('open');   
      }
    } else {
      var checkBoxName = $(event.target).parent().parent().next('.editwidgets').find('.viewSetting:first').attr('name');  
      var vt = $(event.target).parent().parent().next('.editwidgets').find('input[name="'+checkBoxName+'"]:checked').val();
      if($(event.target).parent().hasClass('open')){
        $(event.target).parent().parent().next('.editwidgets').animate({bottom: "50%",'opacity': 0},200,'linear', function(){
          $(event.target).parent().removeClass('open');
          $(event.target).parent().parent().next('.editwidgets').removeClass('open');
            $(event.target).parents('.example-box').removeClass('open');   
            $(event.target).parents('.example-box').find('section.widgets').css('min-height','auto');
          });
      } else {
        this.settingHt = $(event.target).addClass('open').parent().parent().next('.editwidgets').outerHeight() + 50;
        $(event.target).parents('.example-box').find('section.widgets').css('min-height',this.settingHt);
        $(event.target).parent().addClass('open').parent().next('.editwidgets').addClass('open').animate({bottom: "50%",'opacity': 1},200,'linear');    
        $(event.target).parents('.example-box').addClass('open');   
      }
    }

    if(typeof(checkBoxName) != 'undefined'){
      if(vt == 'H'){
        this.sizeOptions = [5,10,15,20,25,50,75,100];
      } else {
        this.sizeOptions = [3,6,9,12]; 
      }
    }  
    if($("div").find("BulletinWId")){
      this.widgetSettingsService.bulletinList().subscribe((data) => {
        this.bulletinList = data.data;    
      });
    }
      if($("div").find("ResourceListLId")){   
        this.widgetSettingsService.getResourcesList().subscribe((data) => {
        this.resourceLists = data.data;   
        })
      }
      if($("div").find("ExplorePageId")) {      
              this.widgetSettingsService.getExplorePages().subscribe((data) => {
        this.explorePage = data.data;  
              })
            }
  }

  colseSettingModal(event){
      $(event.target).parents('.editwidgets').animate({bottom: "50%",'opacity': 0},200,'linear', function(){ 
      $(event.target).parents('.editwidgets').toggleClass('open');
      $(event.target).parents('.example-box').toggleClass('open').find('.edit-widgets-btn').find('.btn-edit').toggleClass('open');    
      $(event.target).parents('.example-box').find('section.widgets').css('min-height','auto');
    }); 
  }


  //change view style from card(thumbnail) to scroll(left to right)
  changeView(typeView){
    if(typeView == 'card'){
      this.sizeOptions = [3,6,9,12];
    } else {
      this.sizeOptions = [5,10,15,20,25,50,75,100];
    }
  }

  //To save new in library widget.
  saveNewInLibaraySetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#NewInLibarayId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="NewInLibarayView'+wid+'"]:checked').val();
    var listSize = $(event.target).parents('.editwidgets').find('#NewInLibaraySize').val();
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    } else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.newInPopularSetting(viewType, listSize, wid, token).subscribe((data) => {      
      if(data.status){
        this.updateWidgetContent('#NewInLibarayId', event.target);
        
        //$('#NewInLibarayId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#NewInLibarayId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
          this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //To save message or text widget
  saveMessageSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#messageId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="messageView'+wid+'"]:checked').val();
    var content = $(event.target).parents('.editwidgets').find('#contentMessage').val();
    var caption = $(event.target).parents('.editwidgets').find('input[name="caption"]').val();
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    } else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.messageSetting(wid, viewType, content, caption,token).subscribe((data) => {      
      if(data.status){
        this.updateWidgetContent('#messageId',event.target);
        //$('#NewInLibarayId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#messageId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
          this.notifier.notify( 'error', "Something went wrong.");
          this.logout();
    });
  }

  //To save popular title widget.
  savePopularTitlesSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#PopularTitlesId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="PopularTitlesView'+wid+'"]:checked').val();
    var listSize = $(event.target).parents('.editwidgets').find('#PopularTitlesSize').val();
     //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.popularTitlesSetting(viewType, listSize, wid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#PopularTitlesId', event.target);
        //$('#PopularTitlesId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#PopularTitlesId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
          this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //To save recommended for you widget.
  saveRecommendedForYouSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#RecommendedForYouId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="RecommendedForYouView'+wid+'"]:checked').val();
    var listSize = $(event.target).parents('.editwidgets').find('#RecommendedForYouSize').val();
    var fallback = $(event.target).parents('.editwidgets').find('input[name="RecommendedForYouFallback'+wid+'"]:checked').val();
    var showPopularWithPrompt = $(event.target).parents('.editwidgets').find('#RecommendedForYouShowPopularPrompt').is(':checked');
     //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.recommendedForYouSetting(viewType, listSize, fallback, showPopularWithPrompt, wid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#RecommendedForYouId', event.target);
      } else {
        $('#RecommendedForYouId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
          this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //To save resource list widget (this is single list functions...)
  saveResourceListSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#ResourceListId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="ResourceListView'+wid+'"]:checked').val();
    var listSize = $(event.target).parents('.editwidgets').find('#ResourceListSize').val();
    var wlid = $(event.target).parents('.editwidgets').find('#ResourceListLId').val();
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.resourseListSetting(viewType, listSize, wid, wlid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#ResourceListId', event.target);
        //$('#ResourceListId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#ResourceListId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
      this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //To save reource lists widgets. (This will show all the resource lists.)
  saveResourceListsSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var listSize = $(event.target).parents('.editwidgets').find('#ResourceListsSize').val();
    var wid = $(event.target).parents('.editwidgets').find('#ResourceListsId').val();
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.resourseListsSetting(listSize, wid, token).subscribe((data) => {
      if(data.status){
        $().attr('value','save').removeAttr('disabled');
        this.updateWidgetContent('#ResourceListLId', event.target);
        //$('#ResourceListLId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#ResourceListLId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
      this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //This will save recent review widget.
  saveRecentReviewsSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#RecentReviewsId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="RecentReviewsView'+wid+'"]:checked').val();
    var listSize = $(event.target).parents('.editwidgets').find('#RecentReviewsSize').val();
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.recentReviewsSetting(viewType, listSize, wid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#RecentReviewsId', event.target);
        //$('#RecentReviewsId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#RecentReviewsId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
      this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //To save bulletin widget.
  saveBulletinListSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#BulletinListId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="BulletinListView'+wid+'"]:checked').val();
    var listSize = $(event.target).parents('.editwidgets').find('#BulletinListSize').val();    
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired. Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.bulletinListSetting(viewType, listSize, wid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#BulletinListId', event.target);
        //$('#BulletinListId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#BulletinListId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
      this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //To save bulletin setting... (Like: size type etc...)
  saveBulletinSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#BulletinId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="BulletinView'+wid+'"]:checked').val();
    var bid = $(event.target).parents('.editwidgets').find('#BulletinWId').val();
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.bulletinSetting(viewType, bid, wid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#BulletinId', event.target);
        //$('#BulletinId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#BulletinId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
      this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //To save calendar widget settings.
  saveCalendarSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var viewType = $(event.target).parents('.editwidgets').find('input[name="CalendarView"]:checked').val();
    var messagec = $(event.target).parents('.editwidgets').find('#CalendarMessage').val();
    var wid = $(event.target).parents('.editwidgets').find('#CalendarId').val();
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info')){
        var token =  localStorage.getItem('token');
    }  else {
      this.notifier.notify( 'error', 'Login Expired.Please login again');
      this.logout();
      return false;
    }
    return this.widgetSettingsService.calendarSetting(viewType, messagec, wid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#CalendarId', event.target);
        //$('#CalendarId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#CalendarId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
      this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //TO save explore buttons widget's settings.
  saveExploreSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#ExploreId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="ExploreView'+wid+'"]:checked').val();
    var pageId = $(event.target).parents('.editwidgets').find('select#ExplorePageId').val();
    //if(this.cookieService.check( 'info')){
      var token =  localStorage.getItem('token');
    //}  else {
      //this.notifier.notify( 'error', 'Login Expired.Please login again');
      //this.logout();
      //return false;
    //}
    return this.widgetSettingsService.exploreViewSetting(viewType,pageId, wid, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#ExploreId', event.target);
        //$('#ExploreId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#ExploreId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
    
      this.notifier.notify( 'error', "Something went wrong.");
    });
  }

  //TO save links widget.
  saveLinksSetting(event){
    
    var wid = $(event.target).parents('.editwidgets').find('#LinksId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="LinksView'+wid+'"]:checked').val();
    var captionW = $(event.target).parents('.editwidgets').find('input[name="LinksCaptions"]').val();
    let links : any[] = [];
    var error = 0;
    var thiss = this;
    $(event.target).parents('.editwidgets').find("small.text-danger").remove();
    $(event.target).parents('.editwidgets').find('div.LinksDetails').each(function(){
      let link : object = {};
      if($.trim($(this).find('input[name="title"]').val().toString()) != ''  && $.trim($(this).find('input[name="url"]').val().toString()) != ''){
        link['caption'] = $(this).find('input[name="title"]').val();
        link['url'] = $(this).find('input[name="url"]').val();
        if(thiss.validateUrl(link['url']) == false){
          var errorMsg = '<small class="text-danger ">Please enter correct URL</small>';
          $(this).find('input[name="url"]').parent().append(errorMsg);
          error++;
        }
        //console.log(thiss.validateUrl(link['url']));
        links.push(link);
      }
    });
    if(error > 0){
      return false;
    }

    $(event.target).attr('value','saving...').attr('disabled','disabled');

    //if(this.cookieService.check( 'info')){
      var token =  localStorage.getItem('token');
    //}  else {
      //this.notifier.notify( 'error', 'Login Expired.Please login again');
      //this.logout();
      //return false;
    //}
    return this.widgetSettingsService.linksSetting(viewType, captionW, wid, links, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#LinksId', event.target);
        //$('#LinksId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $(event.target).parents('.editwidgets').find('#LinksId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
    
      this.notifier.notify( 'error', "Something went wrong.");
    }); 
  }

  validateUrl(value) {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
  }

  //To save Q&A widgets.
  saveQASetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#QAId').val();
    var caption = $(event.target).parents('.editwidgets').find('#QACaption').val();
    var image = $(event.target).parents('.editwidgets').find('#QAImage').val();

    let quesAns : any[] = [];

    $(event.target).parents('.editwidgets').find('div.QAList').each(function(){
      let QA : object = {};
      if($.trim($(this).find('input[name="question"]').val().toString()) != ''  && $.trim($(this).find('textarea[name="answer"]').val().toString()) != ''){
        QA['q'] = $(this).find('input[name="question"]').val();
        QA['a'] = $(this).find('textarea[name="answer"]').val();
        quesAns.push(QA);
      }
    });    
    //if(this.cookieService.check( 'info')){
      var token =  localStorage.getItem('token');
    //}  else {
      //this.notifier.notify( 'error', 'Login Expired.Please login again');
      //this.logout();
      //return false;
    //}
    return this.widgetSettingsService.qaSetting(caption, wid, quesAns,image,token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#QAId', event.target);
        //$('#LinksId').parents('.editwidgets').find('.CloseIcon').trigger('click');
      } else {
        $('#QAId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
     
      this.notifier.notify( 'error', "Something went wrong.");
    }); 
  }

  //Save location and hours widget.
  saveLocationHoursSetting(event){
    $(event.target).attr('value','saving...').attr('disabled','disabled');
    var wid = $(event.target).parents('.editwidgets').find('#LocationHoursId').val();
    var viewType = $(event.target).parents('.editwidgets').find('input[name="LLView'+wid+'"]:checked').val();
    var LocationText = $(event.target).parents('.editwidgets').find('#LocationText').val();
    var LocationMap = $(event.target).parents('.editwidgets').find('#LocationMap').val();

    let hours : any[] = [];

    $(event.target).parents('.editwidgets').find('div.LocationHours').each(function(){
      let hour : object = {};
      if($.trim($(this).find('input[name="Caption"]').val().toString()) != ''  && $.trim($(this).find('input[name="Hours"]').val().toString()) != ''){
        hour['caption'] = $(this).find('input[name="Caption"]').val();
        hour['hours'] = $(this).find('input[name="Hours"]').val();
        hours.push(hour);
      }
    });    
    //if(this.cookieService.check( 'info')){
      var token =  localStorage.getItem('token');
    //}  else {
      //this.notifier.notify( 'error', 'Login Expired.Please login again');
      //this.logout();
      //return false;
    //}
    return this.widgetSettingsService.locationHoursSetting(viewType, LocationMap, LocationText, wid, hours, token).subscribe((data) => {
      if(data.status){
        this.updateWidgetContent('#LocationHoursId', event.target);        
      } else {
        $('#LocationHoursId').after('<span class="success error">Something went wrong. Try Again</span>');
      }
      setTimeout(function(){
        $('span.success').remove();
      },10000);
    },(error)=>{
    
      this.notifier.notify( 'error', "Something went wrong.");
    });

  }

  //To add new link, in links widget.
  addNewLink(event){
    var linkDiv = $(event.target).parents('.example-box').find('#linksWidgetsCon').find('.LinksDetails:first').clone();
    linkDiv.find('input').val('');
    linkDiv.find('.sa_abso_delete_icon').removeClass('hide');
    $(event.target).parents('.example-box').find('#linksWidgetsCon').find('.LinksDetails:last').after(linkDiv);
    this.settingHt = $(event.target).parents('.editwidgets').outerHeight() + 50;
    $(event.target).parents('.example-box').find('section.widgets').css('min-height',this.settingHt);    
  }

  addNewLocationHour(event){
    var llDiv = $(event.target).parents('.example-box').find('#locationHourSetting').find('.LocationHours:first').clone();
    llDiv.find('.sa_abso_delete_icon').removeClass('hide');
    $(event.target).parents('.example-box').find('#locationHourSetting').find('.LocationHours:last').after(llDiv);
    this.settingHt = $(event.target).parents('.editwidgets').outerHeight() + 50;
    $(event.target).parents('.example-box').find('section.widgets').css('min-height',this.settingHt);     
    setTimeout(function(){
      llDiv.find('input').val('');
    },100);

  }

  //Add new question to Q&A widget.
  addNewQuestion(event){
    var QADiv = $(event.target).parents('#QAwidget').find('.QAList:first').clone();
    QADiv.find('textarea').val('');
    QADiv.find('input').val('');
    QADiv.find('.sa_abso_delete_icon').removeClass('hide');
    $(event.target).parents('#QAwidget').find('.QAList:last').after(QADiv);
    this.settingHt = $(event.target).parents('.editwidgets').outerHeight() + 50;
    $(event.target).parents('.example-box').find('section.widgets').css('min-height',this.settingHt);     
  }

  //Checking for widget setting
  updateWidgetContent(id, selector) {
      this.homepageService.getwidgetsupdatedSetting().subscribe((data) => {
          this.widgetsSetting = data;              
          this.getSavedConfig();
          $(id).parents('.editwidgets').find('.CloseIcon').trigger('click');
          $(selector).attr('value','save').removeAttr('disabled');
        })
  }

  //Spare function need to use after BE provide some API for that.
  removeOptions(event){
    //$(event.target).parent('.sa_rel_delete_cont').remove();
  }
  
  drop(event) {
    var wid = this.widgetsSetting.data[event.previousIndex].id;
    var newIndex = parseInt(event.currentIndex) + 1;
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    }
    this.homepageService.reOrderWidgets(wid, newIndex,token).subscribe((data) => {      
    
    });
    moveItemInArray(this.widgetsSetting.data, event.previousIndex, event.currentIndex);

  }

  onSortFinish(evt){
    var wid = $(evt.item).attr('wid');
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    }
    var newIndex = parseInt(evt.newIndex) + 1;
    this.isReload = true;
    this.changeWidgetSettingPosition(Number(wid), Number(evt.newIndex));
    this.homepageService.reOrderWidgets(wid, newIndex,token).subscribe((data) => {
      //moveItemInArray(this.widgetsSetting.data, event.oldIndex, event.newIndex);      
    });
  }

  removeImage(event, inputId){
    $(event.target).parents('.editwidgets-book').removeClass('haveImage').addClass('removedImage');
    $(event.target).parents('span.example-box').find('#'+inputId).val('');
  }


  selectQAImage(event){
      $('document').find('.example-box').removeClass('activeQA');
     var selectImage = $(event.target).attr('id');
     $('.activeQA').find('#QAImage').val(selectImage);   
     $(event.target).parent().addClass('selected');
     $('.activeQA').find('.editwidgets-book.QA').find('.regularImage').attr('src',$(event.target).attr('src'));
     $('.activeQA').find('.editwidgets-book.QA').removeClass('removedImage').addClass('haveImage');
     $('#closeQAChoose').trigger('click'); 
  }  


  //Only initializing froala editor, need to update the all image upload to this editor in future.
  initFroala($event){
    
  }

  showDeleteConfirmation(event, id) {
    this.showDeleteConfirm = true;
    this.deleteWidgetId = id;
    this.deleteWidgetEvent = event;
  }

  hideDeleteConfirmation() {
    this.showDeleteConfirm = false;
  }

  //Delete any widget.
  deleteWidget(){
    var token =  localStorage.getItem('token'); 
    var self = this;
    this.showDeleteConfirm = false;
    $(this.deleteWidgetEvent.target).parents('span.example-box').remove();
    this.widgetSettingsService.deleteWidgets(this.deleteWidgetId, token).subscribe((data) => {

      },(error)=>{
        var refreshToken = localStorage.getItem('refreshToken');
        this.authService.refreshAccessToken(refreshToken).subscribe((refresh:any)=>{
          localStorage.setItem('token', refresh.access_token);
          localStorage.setItem('refreshToken', refresh.refresh_token);
          this.deleteWidget();
        },(errorRefresh)=>{
          this.notifier.notify( 'error', "Something went wrong.");
          this.logout();
        });
      });
  }

  //Add widget when clicking on widget to add (this will open form to add.)
  AddWidgetUpdate(){
    this.homepageService.getwidgetsupdatedSetting().subscribe((data) => {
     this.widgetsSetting = data;              
      this.getSavedConfig();  
      this.showManageWidhetsForm = false;
      this.addWidgetResponce = false;
       setTimeout(function(){
        $("html, body").animate({ scrollTop: $(document).height() - 300  }, 1000);
        $('main.example-list').find('span.example-box:last').find('button.btn-edit').trigger('click');        
        //$('main.example-list').find('span.example-box:last').find('div.edit-widgets-btn').addClass('hide');                
        //$('main.example-list').find('span.example-box:last').find('.CloseIcon').addClass('hide');                
        },1000);
    });
  }

  //This will add the widget to HTML view.
  addWidget(event){    
    //if(this.cookieService.check( 'info')){
    var token = localStorage.getItem('token');
    //} else {
      //this.notifier.notify( 'error', 'Login Expired.Please login again');
      //this.logout();
      //return false;
    //}
    this.addWidgetResponce = true;
    var widgetType = $(event.target).attr('id');
    if( widgetType == 'Message'){
      this.widgetSettingsService.messageSetting('', 'F', '',"", token).subscribe((data) => {
          this.AddWidgetUpdate();
       },(err) => {
        
      });
    } else if(widgetType == 'Calendar'){
      this.widgetSettingsService.calendarSetting('F', '','', token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {
       
      });
    } else if(widgetType == 'BulletinList'){
      this.widgetSettingsService.bulletinListSetting('F', '6', '', token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {
      
      });
    } else if(widgetType == 'Bulletin'){
        this.widgetSettingsService.bulletinList().subscribe((data) => {
      this.bulletinList = data.data;       
      if(typeof(this.bulletinList[0]) != 'undefined'){
        var id = this.bulletinList[0].id;
        this.widgetSettingsService.bulletinSetting('F', id, '', token).subscribe((data) => {
          this.AddWidgetUpdate();
        },(err) => {
       
      });    
      } else {
        this.addWidgetResponce = false;
        this.notifier.notify( 'error', 'No bulletin created yet.' );      
      }  
    });
     
    } else if(widgetType == 'Links'){
      this.widgetSettingsService.linksSetting('F', '', '', [], token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {
      
      });     
    } else if(widgetType == 'NewinLibrary'){
      this.widgetSettingsService.newInPopularSetting('H', 6, '',  token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {
       
      });     
    } else if(widgetType == 'PopularTitles'){
      this.widgetSettingsService.popularTitlesSetting('H', 6, '', token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {
      
      });     
    } else if(widgetType == 'RecommendedForYou'){
      this.widgetSettingsService.recommendedForYouSetting('H', 6, 'PromptLogin', false, '', token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {

      });     
    } else if(widgetType == 'ReadingList'){   
          this.widgetSettingsService.getResourcesList().subscribe((data) => {
      this.resourceLists = data.data;   
      if(typeof(this.resourceLists[0]) == 'undefined'){
        this.addWidgetResponce = false;
        this.notifier.notify( 'error', 'No Resource list created yet.' );      
      } else {
        var id = this.resourceLists[0].id;
        this.widgetSettingsService.resourseListSetting('H', 6, '', id,  token).subscribe((data) => {
          this.AddWidgetUpdate();
        },(err) => {
        
      });     
      }
    });   
    
    } else if(widgetType == 'ReadingLists'){      
      this.widgetSettingsService.resourseListsSetting(6, '', token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {
       
      });     
    } else if(widgetType == 'Reviews'){      
      this.widgetSettingsService.recentReviewsSetting('H', 6, '', token).subscribe((data) => {
        this.AddWidgetUpdate();
       },(err) => {
        
      });     
    } else if(widgetType == 'HoursandLocation'){      
      this.widgetSettingsService.locationHoursSetting('F','', '', '', '', token).subscribe((data) => {
        this.AddWidgetUpdate();
      },(err) => {
       
      });     
    } else if(widgetType == 'Explore') {      
      this.widgetSettingsService.exploreViewSetting('F',0, '', token).subscribe((data) => {
            this.widgetSettingsService.getExplorePages().subscribe((data) => {
      this.explorePage = data.data;   
      this.AddWidgetUpdate();      
    });
       
      },(err) => {
       
      });     
    } else if(widgetType == 'QAWdg') {      
      this.widgetSettingsService.qaViewSetting('', [], '', token).subscribe((data) => {
        this.AddWidgetUpdate();
      },(err) => {
      
      });     
    }
  }

  //refresh token on add widget
  refreshTokenAddWidget(elements){
    var refreshToken = localStorage.getItem('refreshToken');
    this.authService.refreshAccessToken(refreshToken).subscribe((refresh:any)=>{
      localStorage.setItem('token', refresh.access_token);
      localStorage.setItem('refreshToken', refresh.refresh_token);
      this.addWidget(elements);
    },(errorRefresh)=>{
      this.notifier.notify( 'error', "Something went wrong.");
      this.logout();
    });
  }

  //User can choose QA image.
  chooseImageQAopen(event){
    this.QaImagesList = false;
    $(event.target).parents('.example-box').addClass('activeQA');
    this.widgetSettingsService.getQaImage().subscribe((data) => {
      if(data.status){
        this.qaImagesList = data.data;
        this.QaImagesList = true;
      } 
    });
  }

  //This is just showing active image.
  unselectQAImage(event){
   $('body').find('.example-box').removeClass('activeQA');
  }

  //Upload Q&A image.
  //uploadImage(img, response){
    //console.log(img, response);
  //} 

  //Upload Q&A image.
  uploadImageQa(files: FileList,event) {
    $(event.target).parents('div.editwidgets').find('input[value="Save"]').attr('value','uploading...').attr('disabled','disabled');

    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    }
    this.fileToUpload = files.item(0); 
    let formData = new FormData(); 
    formData.append('file', this.fileToUpload, this.fileToUpload.name); 
    this.widgetSettingsService.qaImageUpload(token,formData).subscribe((data) => {
      if(data.status){
        $(event.target).parents('div.editwidgets').find('input[value="uploading..."]').attr('value','Save').removeAttr('disabled');
        $(event.target).parents('div.editwidgets').find('.editwidgets-book.QA').removeClass('removedImage').addClass('haveImage').find('img.regularImage').attr('src',data.data.url);
        $(event.target).parents('div.editwidgets').find('#QAImage').val(data.data.url);
      }
    });
  }

  //Logout user.
  logout(){
    this.showManageWidhetsForm = false;
    this.addWidgetResponce = false;
    this.cookieService.deleteAll('/');
    $('li#loginLi').addClass('show').removeClass('hide');
    $('li#profileLi').removeClass('show').addClass('hide');
    $('li#myCollectionLi').removeClass('show').addClass('hide');
    this.document.body.classList.remove('login-patron');
    this.document.body.classList.remove('manage-view');
    localStorage.removeItem('selectedResourcesIds');
    localStorage.removeItem('token');
    this.router.navigate(['/']);
    setTimeout(function(){
      document.getElementById("loginLia").click();
    },2000);
  }

  //Change theme function
  changeTheme(event, theme, name){
    //if(this.cookieService.check( 'info')){3
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    } else {
      this.notifier.notify( 'error', 'Login Expired. Please login again');
      this.logout();
      return false;
    }
    if(localStorage.getItem('theme') == name)
      return false;
    else{
      this.updateColors(name);
    }
    localStorage.setItem('theme', name);
    this.homepageService.updateThemeName(name);
    if($('body').hasClass('custom-theme'))
      $('body').removeClass('custom-theme');
      //$('html').removeAttr('style');
    if($('body').hasClass('custom-dark-theme'))
      $('body').removeClass('custom-dark-theme');
    if($('body').hasClass('kids1-theme beach-theme'))
      $('body').removeClass('kids1-theme beach-theme');
    if($('body').hasClass('kids1-theme christmas-theme'))
      $('body').removeClass('kids1-theme christmas-theme');
    if($('body').hasClass('kids1-theme kids2-theme'))
      $('body').removeClass('kids1-theme kids2-theme');
    if($('body').hasClass('kids1-theme'))
      $('body').removeClass('kids1-theme');
    if($('body').hasClass('dark-theme'))
      $('body').removeClass('dark-theme');
    if($('body').hasClass('SleekAndRelaxed'))
      $('body').removeClass('SleekAndRelaxed');
    if($('body').hasClass('violet-theme'))
      $('body').removeClass('violet-theme');
    if($('body').hasClass('default'))
      $('body').removeClass('default');
    if(theme != 'summertime'){
      $('body').addClass(theme);
    }
    $('.themeIcon').removeClass('active');
    $(event.target).parents('.themeIcon').addClass('active');
    this.homepageService.updateTheme(token, name).subscribe((data:any) => {
      //console.log('Theme Changed');
    });
  }

//color_picker------------------- 
  customTheme(theme){
    var currentTheme = this.theme;
    //console.log(currentTheme);
    if($('body').hasClass('kids1-theme beach-theme'))
      $('body').removeClass('kids1-theme beach-theme');
    if($('body').hasClass('kids1-theme christmas-theme'))
      $('body').removeClass('kids1-theme christmas-theme');
    if($('body').hasClass('kids1-theme kids2-theme'))
      $('body').removeClass('kids1-theme kids2-theme');
    if($('body').hasClass('kids1-theme'))
      $('body').removeClass('kids1-theme');
    if($('body').hasClass('dark-theme'))
      $('body').removeClass('dark-theme');
    if($('body').hasClass('SleekAndRelaxed'))
      $('body').removeClass('SleekAndRelaxed');
    if($('body').hasClass('violet-theme'))
      $('body').removeClass('violet-theme');
    if($('body').hasClass('default'))
      $('body').removeClass('default');
    if($('body').hasClass('custom-theme'))
      $('body').removeClass('custom-theme');
    if($('body').hasClass('custom-dark-theme'))
      $('body').removeClass('custom-dark-theme');
    if(currentTheme == 'luna' || currentTheme == 'custom-dark-theme'){
      $('body').addClass('custom-dark-theme');
      this.homepageService.updateThemeName('custom-dark-theme');
    }else{
      $('body').addClass(theme);
      this.homepageService.updateThemeName('custom-theme');
    }
  }
  // 
  colorPicker(id, event){ 
    document.documentElement.style.setProperty(`--`+id, event); 
  }

  revertTheme(event){
    var tempName = '';
    if($('body').hasClass('custom-theme')){
      $('body').removeClass('custom-theme');
    }
    if($('body').hasClass('custom-dark-theme')){
      $('body').removeClass('custom-dark-theme');
    }
    var theme = localStorage.getItem('theme');
    //console.log(theme, '********');
    if(theme.indexOf('custom') > -1){ 
      var customColors = theme.split(' ');
      $('body').addClass(customColors[0]);
      this.color1 = customColors[1];  
      this.color2 = customColors[2];  
      this.color3 = customColors[3];  
      this.color4 = customColors[4];  
      this.color5 = customColors[5];  
      document.documentElement.style.setProperty(`--first`, this.color1 );  
      document.documentElement.style.setProperty(`--second`, this.color2 ); 
      document.documentElement.style.setProperty(`--third`, this.color3 );  
      document.documentElement.style.setProperty(`--fourth`, this.color4 ); 
      document.documentElement.style.setProperty(`--fifth`, this.color5 );
      this.homepageService.updateThemeName(customColors[0]); 
    }else{  
      var name = Object.keys(this.themes).find(key => this.themes[key] === theme);
      //console.log(theme, name , '********');
      $('body').addClass(name);
      this.homepageService.updateThemeName(theme);
      this.updateColors(theme);
    }
  }

  //save-custom-theme
  saveCustomTheme(){
    var themeName = this.theme;
    var firstColor = $('#colorPicker').find('#first').val();
    var secondColor = $('#colorPicker').find('#second').val();
    var thirdColor = $('#colorPicker').find('#third').val();
    var fourthColor = $('#colorPicker').find('#fourth').val();
    var fifthColor = $('#colorPicker').find('#fifth').val();
    var nameToSave = themeName+' '+firstColor+' '+secondColor+' '+thirdColor+' '+fourthColor+' '+fifthColor;
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    } else {
      this.notifier.notify( 'error', 'Login Expired. Please login again');
      this.logout();
      return false;
    }
    this.custumThemeLoad=true;
    this.homepageService.updateTheme(token, nameToSave).subscribe((data:any) => {
      localStorage.setItem('theme', nameToSave);
      $('#colorPicker').find('.close').click();
      this.custumThemeLoad=false;
      $('.themeIcon').removeClass('active');
      $('body').find('#customThemeIcon').addClass('active');
    });
  }

  updateColors(theme){
    this.color1 = this.themeColors[theme][0];
    this.color2 = this.themeColors[theme][1];
    this.color3 = this.themeColors[theme][2];
    this.color4 = this.themeColors[theme][3];
    this.color5 = this.themeColors[theme][4];
    document.documentElement.style.setProperty(`--first`, this.color1 );  
    document.documentElement.style.setProperty(`--second`, this.color2 ); 
    document.documentElement.style.setProperty(`--third`, this.color3 );  
    document.documentElement.style.setProperty(`--fourth`, this.color4 );
    document.documentElement.style.setProperty(`--fifth`, this.color5 );
  }

}  



